import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { money } from "@/lib/utils-app";
import { useStores } from "@/lib/stores";
import { logError } from "@/lib/logger";
import { TrendingUp, Package } from "lucide-react";

export default function AdminRankings() {
  const { activeStore, activeStoreObj } = useStores();
  const [data, setData] = useState({ items: [], total_units: 0, total_revenue: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => {
    setLoading(true);
    try {
      const qs = activeStore ? `?store_id=${activeStore}` : "";
      const r = await api.get(`/admin/analytics/parts${qs}`);
      setData(r.data);
    }
    catch (err) {
      if (err?.response?.status !== 401) logError("[rankings] load:", err);
    }
    finally { setLoading(false); }
  })(); }, [activeStore]);

  const max = data.items[0]?.count || 1;

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl">
      <div className="text-xs uppercase tracking-[0.25em] font-bold text-neutral-500 mb-3">Inteligência de estoque</div>
      <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Ranking de Peças</h1>
      <p className="mt-2 text-neutral-600 text-sm">Peças mais trocadas em todas as OS. Use para reabastecer estoque e gerar orçamentos mais rápido.</p>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <div className="bg-white border border-neutral-200 rounded-xl p-5">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold flex items-center gap-2"><Package size={12}/> Total de unidades</div>
          <div className="mt-2 text-3xl font-heading font-black">{data.total_units}</div>
        </div>
        <div className="bg-white border border-neutral-200 rounded-xl p-5">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold flex items-center gap-2"><TrendingUp size={12}/> Receita em peças</div>
          <div className="mt-2 text-3xl font-heading font-black font-mono">{money(data.total_revenue)}</div>
        </div>
        <div className="bg-white border border-neutral-200 rounded-xl p-5">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold">Modelos rastreados</div>
          <div className="mt-2 text-3xl font-heading font-black">{data.items.length}</div>
        </div>
      </div>

      <div className="mt-8 bg-white border border-neutral-200 rounded-xl overflow-hidden">
        <div className="px-5 py-4 border-b border-neutral-100 flex items-center justify-between">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold">Top peças por unidade</div>
          <div className="text-xs text-neutral-400">Ordenado por quantidade instalada</div>
        </div>
        <div className="divide-y divide-neutral-100">
          {loading && <div className="p-8 text-center text-neutral-500 text-sm">Carregando…</div>}
          {!loading && data.items.length === 0 && <div className="p-10 text-center text-neutral-500 text-sm">Sem dados ainda — quando você adicionar peças em algumas OS, elas aparecem aqui.</div>}
          {data.items.map((p, i) => (
            <div key={p.name ?? `part-${i}`} className="grid grid-cols-12 items-center gap-4 px-5 py-3 hover:bg-neutral-50" data-testid={`part-rank-${i}`}>
              <div className="col-span-1 text-neutral-400 font-mono text-sm">#{i+1}</div>
              <div className="col-span-4">
                <div className="font-semibold text-neutral-900 truncate">{p.name}</div>
                <div className="text-xs text-neutral-500">Preço médio {money(p.avg_price)}</div>
              </div>
              <div className="col-span-4">
                <div className="h-2 bg-neutral-100 rounded-full overflow-hidden">
                  <div className="h-full bg-neutral-900" style={{ width: `${(p.count / max) * 100}%` }} />
                </div>
              </div>
              <div className="col-span-1 text-right font-mono font-bold">{p.count}</div>
              <div className="col-span-2 text-right font-mono text-neutral-700">{money(p.revenue)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
